import { Clock, ShieldCheck, Wallet, MapPin } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { Reveal, Overline } from "@/components/site/Reveal";

export const Location = ({ prop }) => {
  const { t, pick } = useI18n();
  const { lat = 9.880637, lng = -85.529796 } = prop?.location || {};
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${lng - 0.006},${lat - 0.004},${lng + 0.006},${lat + 0.004}&layer=mapnik&marker=${lat},${lng}`;
  return (
    <section id="location" data-testid="location-section" className="mx-auto max-w-[1280px] px-5 py-24 sm:px-8">
      <div className="grid gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <Overline>{t("loc.title")}</Overline>
          <h3 className="mt-4 font-display text-4xl leading-[1.05] text-ink sm:text-5xl">{prop?.location?.area}</h3>
          <p className="mt-5 text-[15px] leading-relaxed text-body2">{t("loc.text")}</p>
          <p className="mt-6 border-t border-ink/10 pt-6 font-display text-xl italic leading-snug text-muted2">{t("about.area")}</p>
          <p data-testid="neighborhood-text" className="mt-2 text-[15px] leading-relaxed text-body2">{pick(prop?.neighborhood)}</p>
        </Reveal>
        <Reveal delay={0.1} className="relative lg:col-span-8">
          <div className="relative h-[380px] overflow-hidden rounded-[28px] border border-ink/10 sm:h-[520px]">
            <iframe title="map" data-testid="location-map" src={src} className="h-full w-full [filter:sepia(0.35)_saturate(0.9)]" loading="lazy" />
            <div className="pointer-events-none absolute left-4 top-4 flex items-center gap-2 rounded-full bg-ink px-4 py-2 text-xs text-paper"><MapPin className="h-3.5 w-3.5 text-gold" /> Playa Sámara · 50 m</div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export const Rules = ({ prop }) => {
  const { t } = useI18n();
  const cols = [
    [Clock, t("ru.house"), [t("ru.inn", { a: prop?.checkin_from, b: prop?.checkin_to }), t("ru.out", { t: prop?.checkout_by }), t("ru.max", { n: prop?.max_guests })]],
    [ShieldCheck, t("ru.cancel"), [t("ru.cancelText")]],
    [Wallet, t("ru.pay"), [t("ru.payText")]],
  ];
  return (
    <section data-testid="rules-section" className="mx-auto max-w-[1280px] border-t border-ink/10 px-5 py-20 sm:px-8">
      <Reveal><h3 className="font-display text-4xl text-ink">{t("ru.title")}</h3></Reveal>
      <div className="mt-10 grid gap-10 md:grid-cols-3">
        {cols.map(([I, title, items], i) => (
          <Reveal key={i} delay={i * 0.08}>
            <I className="h-6 w-6 text-accent2" strokeWidth={1.5} />
            <p className="mt-4 font-semibold text-ink">{title}</p>
            {items.map((x, j) => <p key={j} className="mt-2 text-[15px] leading-relaxed text-body2">{x}</p>)}
          </Reveal>
        ))}
      </div>
    </section>
  );
};
